export const DATE_FORMATS = {
    EUROPEAN_DASH: 'DD-MM-YYYY',
    PROFESSIONAL: 'DD-MMM-YYYY',
    EUROPEAN_SLASH: 'DD/MM/YYYY',
    US: 'MM/DD/YYYY',
    ISO: 'YYYY-MM-DD',
};

export const TIME_FORMATS = {
    twentyFourHours: 'HH:mm',
    twelveHours: 'hh:mm A',
};
